import React, { useContext, useEffect, useMemo } from 'react';
import { array } from 'prop-types';
import classNames from 'classnames/bind';

import ResourcesItem from './components/ResourcesItem';
import DocumentItem from './components/DocumentItem';

import WithBlurPopin from 'containers/WithBlurPopin';

import { StaticTextContext } from 'context/StaticTextContext';

import styles from './TabResources.module.scss';
const cx = classNames.bind(styles);

const TabResources = ({ data, documents }) => {
  const { labels } = useContext(StaticTextContext);
  const dataBulletin = useMemo(
    () => data.filter((item) => item.type === 'technical_bulletin'),
    [data]
  );
  const dataFitting = useMemo(
    () => data.filter((item) => item.type === 'fitting_instruction'),
    [data]
  );
  const dataTrainings = useMemo(
    () => data.filter((item) => item.type === 'trainings'),
    [data]
  );
  const dataTechnicalVideo = useMemo(
    () => data.filter((item) => item.type === 'technical_video'),
    [data]
  );

  useEffect(() => {
    // Remove min-height style to prevent jumping tabs on click.
    document.getElementById('product-tabs') &&
      document.getElementById('product-tabs').removeAttribute('style');
  }, []);

  return (
    <div className={cx('tab-content')}>
      <WithBlurPopin>
        {dataBulletin.length > 0 && (
          <div className={cx('items-group')}>
            <h4 className={cx('title')}>{labels.resourcesBulletinInfoTitle}</h4>
            {dataBulletin.map((item, index) => (
              <ResourcesItem item={item} key={index} />
            ))}
          </div>
        )}
        {dataFitting.length > 0 && (
          <div className={cx('items-group')}>
            <h4 className={cx('title')}>
              {labels.resourcesInstructionInfoTitle}
            </h4>
            {dataFitting.map((item, index) => (
              <ResourcesItem item={item} key={index} />
            ))}
          </div>
        )}
        {dataTechnicalVideo.length > 0 && (
          <div className={cx('items-group')}>
            <h4 className={cx('title')}>{labels.resourcesVideoTitle}</h4>
            {dataTechnicalVideo.map((item, index) => (
              <ResourcesItem item={item} key={index} />
            ))}
          </div>
        )}
        {dataTrainings.length > 0 && (
          <div className={cx('items-group')}>
            <h4 className={cx('title')}>{labels.resourcesTrainingsTitle}</h4>
            {dataTrainings.map((item, index) => (
              <ResourcesItem item={item} key={index} />
            ))}
          </div>
        )}
        {documents.length > 0 && (
          <div className={cx('items-group')}>
            <h4 className={cx('title')}>
              {labels.resourcesAdditionalInfoTitle}
            </h4>
            {documents.map((item) => (
              <DocumentItem item={item} key={item.docId} />
            ))}
          </div>
        )}
      </WithBlurPopin>
    </div>
  );
};

TabResources.propTypes = {
  data: array.isRequired,
  documents: array,
};

TabResources.defaultProps = {
  documents: [],
};

export default TabResources;



// WEBPACK FOOTER //
// ./src/pages/Product/components/TabResources/TabResources.js